import React from 'react';
import PropTypes from 'prop-types';

const statusStyles = {
  Pending: { backgroundColor: 'orange', color: 'white' },
  Ongoing: { backgroundColor: 'blue', color: 'white' },
  Completed: { backgroundColor: 'green', color: 'white' },
};

const StatusBadge = ({ status }) => {
  const style = statusStyles[status] || { backgroundColor: 'gray', color: 'white' }; 

  return (
    <div style={{
      ...style,
      padding: '5px 10px',
      borderRadius: '3px',
      display: 'inline-block',
      fontWeight: 'bold',
      textAlign: 'center',
      minWidth: '100px',
    }}>
      {status}
    </div>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.oneOf(['Pending', 'Ongoing', 'Completed']).isRequired,
};

export default StatusBadge;
